module.exports = __webpack_public_path__ + "static/img/maayke.4207967.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dalslider/maayke.png
// module id = +aiu
// module chunks = 1